/// <reference types="vite/client" />
import { algoliasearch } from 'algoliasearch';

const appId = import.meta.env.VITE_ALGOLIA_APP_ID || '';
const searchKey = import.meta.env.VITE_ALGOLIA_SEARCH_KEY || '';

if (!appId || !searchKey) {
  console.warn('Algolia credentials missing in environment variables.');
}

export const algoliaClient = (
  appId && searchKey
    ? algoliasearch(appId, searchKey)
    : ({
        search: () => Promise.resolve({ results: [{ hits: [], nbPages: 0, page: 0 }] }),
      } as unknown)
) as ReturnType<typeof algoliasearch>;

export const FREELANCERS_INDEX = 'freelancers';
export const JOBS_INDEX = 'jobs';
